"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleList = void 0;
const ArticleUtils_1 = require("./ArticleUtils");
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
/**
 * The `ArticleList` manages a List of serializable and cloneable Articles
 */
class ArticleList extends echain_shared_oo_1.List {
    constructor() {
        super(...arguments);
        this.model = [];
    }
    static getAllArtNrs(articleJsons, artNrCountry) {
        return Array.from(new Set(articleJsons
            .map((a) => ArticleUtils_1.ArticleUtils.getQuoteArtNr(a, artNrCountry))
            .filter((artNr) => Boolean(artNr))));
    }
    hasEqualValues(that, comparator) {
        if (comparator)
            return comparator(this, that);
        // the count must equal, otherwise we can leave right here
        if (this.count() !== that.count())
            return false;
        // all in this must have at least 1 in that
        for (const article of this.toArray()) {
            if (!that.getHavingEqualValues(article).length) {
                return false;
            }
        }
        return true;
    }
    fromArray(items) {
        this.items = [...items];
        this.model = items.map((i) => i.toModel());
        return this;
    }
    add(item) {
        if (item == null)
            throw new Error('List.add: item is null or undefined');
        if (this.has(item))
            throw new Error('List.add: item is already listed');
        this.items.push(item);
        this.model.push(item.toModel());
        this._changes$.next();
    }
    addAfter(item, predecessor) {
        if (item == null)
            throw new Error('List.addAfter: item is null or undefined');
        if (this.has(item))
            throw new Error('List.addAfter: item is already listed');
        if (predecessor == null)
            throw new Error('List.addAfter: predecessor is null or undefined');
        if (!this.has(predecessor))
            throw new Error('List.addAfter: predecessor is not listed');
        for (let i = 0, l = this.items.length; i < l; i++) {
            if (this.itemsAreSameEntity(this.items[i], predecessor)) {
                this.items.splice(i + 1, 0, item);
                this.model.splice(i + 1, 0, item.toModel());
                this._changes$.next();
                return;
            }
        }
    }
    replace(oldItem, newItem) {
        for (let i = 0, l = this.items.length; i < l; i++) {
            if (this.itemsAreSameEntity(this.items[i], oldItem)) {
                this.items[i] = newItem;
                this.model[i] = newItem.toModel();
                this._changes$.next();
                return;
            }
        }
    }
    update(item) {
        for (let i = 0, l = this.items.length; i < l; i++) {
            if (this.itemsAreSameEntity(this.items[i], item)) {
                this.items[i] = item;
                this.model[i] = item.toModel();
                this._changes$.next();
                return;
            }
        }
    }
    remove(itemToRemove) {
        for (let i = 0, l = this.items.length; i < l; i++) {
            if (this.itemsAreSameEntity(this.items[i], itemToRemove)) {
                this.items.splice(i, 1);
                this.model.splice(i, 1);
                this._changes$.next();
                return;
            }
        }
    }
    removeAll() {
        this.model.splice(0);
        this.items = [];
        this._changes$.next();
    }
    removeIf(conditionFunc) {
        if (!conditionFunc || !(conditionFunc instanceof Function))
            return;
        const prevCount = this.items.length;
        for (let i = 0; i < prevCount; i++) {
            if (conditionFunc(this.items[i])) {
                this.items.splice(i, 1);
                this.model.splice(i, 1);
            }
        }
        if (prevCount !== this.items.length)
            this._changes$.next();
    }
    sortByArtNr() {
        this.items.sort((a, b) => {
            if (a.artNr && b.artNr && a.artNr < b.artNr) {
                return -1;
            }
            else if (a.artNr === b.artNr) {
                return 0;
            }
            else {
                return 1;
            }
        });
        this.model = this.items.map((i) => i.toModel());
    }
    getAllArtNrs() {
        return [
            ...new Set(this.toArray()
                .map((a) => a.artNr)
                .filter((a) => a != null)),
        ];
    }
}
exports.ArticleList = ArticleList;
//# sourceMappingURL=ArticleList.js.map